<template>
  <div ref="countdownRef" class="countdown-parallax-container">
    <div class="parallax-background">
      <div class="overlay"></div>
    </div>

    <div class="countdown-wrapper">
      <div class="fecha-container">
        <div class="columna-izquierda">
          <p class="dia-texto">SABADO</p>
          <p class="dia-numero">13</p>
        </div>

        <div class="imagen-central">
          <img src="@/assets/ovala.png" alt="Imagen ovalada" class="oval-img" />
        </div>
      <br>      <br>
      <br>
      <br>

        <div class="columna-derecha">
          <p class="mes">DICIEMBRE</p>
          <p class="anio">2025</p>
        </div>
      </div>

        <div class="columna-izq">
                <br>

          <p class="faltan">¡Solo Faltan!</p>
        </div>
      <div class="countdown">
        <div class="item"><div class="fa-font">{{ days }}</div><label>DÍAS</label></div>
        <div class="item"><div class="fa-font">{{ hours }}</div><label>HORAS</label></div>
        <div class="item"><div class="fa-font">{{ minutes }}</div><label>MINUTOS</label></div>
        <div class="item"><div class="fa-font">{{ seconds }}</div><label>SEGUNDOS</label></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'ContadorPersonalizado',
  setup() {
    const countdownRef = ref(null);
    const days = ref('00');
    const hours = ref('00');
    const minutes = ref('00');
    const seconds = ref('00');
    let interval;

    const updateCountdown = () => {
      const eventDate = new Date('2025-12-13T17:30:00');
      const now = new Date();
      const diff = eventDate - now;

      if (diff <= 0) {
        days.value = hours.value = minutes.value = seconds.value = '00';
        clearInterval(interval);
        return;
      }

      days.value = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2, '0');
      hours.value = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, '0');
      minutes.value = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, '0');
      seconds.value = String(Math.floor((diff / 1000) % 60)).padStart(2, '0');
    };

    const animateCountdown = () => {
      const tl = gsap.timeline();
      tl.from('.fecha-container .columna-izquierda p', {
        y: 40,
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.2
      });
      tl.from('.imagen-central img', {
        scale: 0.9,
        opacity: 0,
        duration: 1.2,
        ease: 'power2.out'
      }, '-=1');
      tl.from('.columna-derecha p', {
        y: 40,
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.2
      }, '-=0.8');
      tl.from('.item', {
        y: 20,
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.15
      }, '-=0.8');
    };

    onMounted(async () => {
      await nextTick();
      updateCountdown();
      interval = setInterval(updateCountdown, 1000);

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateCountdown();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      if (countdownRef.value) observer.observe(countdownRef.value);
    });

    onBeforeUnmount(() => {
      clearInterval(interval);
    });

    return { countdownRef, days, hours, minutes, seconds };
  }
};
</script>
<style scoped>
.countdown-parallax-container {
  position: relative;
  min-height: 40vh;
  background-color: #1b1b1b;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 40px; /* aumentados márgenes izq y der */
}

.parallax-background {
  background-image: linear-gradient(to bottom, rgba(26, 25, 25, 0.808), rgba(33, 32, 32, 0.801)), url('@/assets/fondoobscuro.jpg');
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.countdown-wrapper {
  position: relative;
  z-index: 1;
  color: rgb(255, 255, 255);
  text-align: center;
  max-width: 300px;
}

.fecha-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* alineado arriba */
  text-align: center;
  margin-bottom: 50px; /* mayor separación con countdown */
}

.columna-izquierda, .columna-derecha {
  width: 25%;
  font-family: 'Playfair Display', serif;
  color: rgb(247, 244, 244);
}

.dia-texto {
  font-size: 18px;
  letter-spacing: 2px;
}

.dia-numero {
  font-size: 38px;
  font-weight: bold;
}

.mes {
  font-size: 18px;
  letter-spacing: 2px;
  margin-left: -20px;
  margin-top: 200px; /* bajamos OCTUBRE */
}

.anio {
  font-size: 32px;
  font-weight: bold;
}

.imagen-central {
  width: 180px;
  height: auto;
}

.oval-img {
  width: 100%;
  border-radius: 50% / 40%;
  object-fit: cover;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}
.faltan {
  font-family: 'corinthia';
  font-size: 39px;
  margin-top:-60px;
  letter-spacing: 2px;
  
  color: rgb(255, 254, 254);
}
.countdown {
  display: flex;
  justify-content: center;
  gap: 20px; /* más separación entre items */
  margin-top: 0px;
  padding: 0px 20px; /* márgenes extra */
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Playfair Display', serif;
}

.fa-font {
  font-size: 26px;
  color: rgb(255, 255, 255); /* amarillo suave */
  font-family: 'padres', serif;
  font-weight: 400;
  line-height: 1;
}

.item label {
  font-size: 14px;
  letter-spacing: 2px;
  color: rgb(253, 253, 253);
  margin-top: 5px;
}
</style>
